export const summitDistributionDraft = 'draft';
export const summitDistributionSeasonStart = 'seasonStart';
export const summitCardThresholds = [2,4,6,9999];